import { Component, OnInit, OnDestroy } from '@angular/core';
import { TimelineStore } from '../../timeline/timeline.store';
import { Subscriber } from 'rxjs/Subscriber';

@Component({
  selector: 'app-timer',
  templateUrl: 'timer.component.html',
  styleUrls: ['timer.component.styl']
})
export class TimelineTimerComponent implements OnInit, OnDestroy {
  public milliseconds = 0;
  public subscriber: Subscriber<number>;

  constructor(public timelineStore: TimelineStore) {
  }

  ngOnInit() {
    this.updateMilliseconds();

    this.subscriber = this.timelineStore.currentPositionChange
      .subscribe(() => this.updateMilliseconds());
  }

  ngOnDestroy() {
    this.subscriber.unsubscribe();
  }

  updateMilliseconds() {
    this.milliseconds = this.timelineStore.currentPosition;
  }
}



// WEBPACK FOOTER //
// ./src/app/rec/components/timer/timer.component.ts